<div class="panelTerritories" [ngClass]="{'expandir': (fullScreen && !mobileQuery.matches)}"
    id="panelTerritoryContainer">
    <loading [isLoading]="isLoading"></loading>

    <div class="header-panel">
        <div class="btnClose">
            <img [src]="'cancelar.svg' | findUrl" (click)="ClosePanel()">
        </div>

        <h3>Territorios</h3>

        <div class="tools-buttons-container">
            <!-- <div class="tool-button"
                (click)="isSearchButtonPressed = !isSearchButtonPressed; isToolButtonPressed = false"
                id="searchTerritoryButton" matTooltip="Buscar Territorio">
                <img [src]="'busqueda_blanco.svg' | findUrl">
            </div> -->
            <div class="tool-button" [class.disabled]="this.isLoadingFilters" (click)="openFilterTerritoriesDialog()"
                id="toolsTerritoryButton" matTooltip="Herramientas">
                <img [src]="'filtrar_boton.svg' | findUrl">
                <!-- <img *ngIf="!isToolButtonPressed" [src]="'menu_hamburguesa.svg' | findUrl"> -->
                <!-- <img *ngIf="isToolButtonPressed" [src]="'boton_menos_contraer_menu.svg' | findUrl"> -->
            </div>
        </div>
    </div>

    <div class="step-container">
        <div class="step-header">
            <span class="step-badge">1</span>
            <h4 class="step-title">Selecciona rutas para revisar</h4>
        </div>
        <div class="step-description">
            <span class="step-subtitle">Selecciona al menos 2 y máximo 3 rutas para revisar.</span>
        </div>
    </div>

    <!-- <div class="counters-container">
         <div *ngFor="let routeType of TerritoryRouteTypeEnumValues" class="counter-item">
            <span class="counter-color" [style.background-color]="routeType | routeTypeColor"></span>
            <span class="counter-label">{{ territoryRouteTypeAcronymDisplayEnum[routeType] || routeType }}: </span>
            <span class="counter-number-label">{{ itemsCounter[routeType] || 0 }}</span>
        </div>
    </div> -->

    <div class="search-Arrow-flex">
        <div class="searchBar-flex">
            <div class="searchBar" id="searchTerritoryInput" matTooltip="Buscar por Nombre" matTooltipPosition="above">
                <mat-form-field class="width-input">
                    <input #filterTerritory [(ngModel)]="finder" matInput placeholder="Búsqueda por Nombre"
                        spellcheck="false" type="text" (input)="onFindTerritory($event)" />
                </mat-form-field>
            </div>
            <div class="btnResetFilter-container" (click)="resetFilterValue()" *ngIf="finder.length > 0">
                <mat-icon matTooltip="Borrar" aria-hidden="false">cancel</mat-icon>
            </div>
            <div class="btnSearch-container" (click)="onFindTerritory($event)">
                <img class="btnSearchIcon" src="/assets/img/icon_search.png" *ngIf="finder.length == 0">
            </div>
        </div>

        <div *ngIf="!mobileQuery.matches && !fullScreen" (click)="fullScreen = !fullScreen">
            <mat-icon class="mobile-flecha">keyboard_arrow_up</mat-icon>
        </div>
        <div *ngIf="!mobileQuery.matches && fullScreen" (click)="fullScreen = !fullScreen">
            <mat-icon class="mobile-flecha">keyboard_arrow_down</mat-icon>
        </div>
    </div>

    <div class="selected-items-container">
        <div class="selected-items-chip-container">
            <span class="selected-item-chip" *ngFor="let item of selectedItems" [style.border]="'solid 0.1vw ' + (item | territoryAssignedColor)">
                {{ item }} <mat-icon (click)="removeSelectedItem(item)">delete</mat-icon>
            </span>
        </div>
    </div>

    <!-- seccion que maneja filtros aplicados y botón para limpiar filtros (desactivado por ahora)
    <div class="clear-filters-control" *ngIf="!filter && this.areFiltersSelected && (layerTerritoriesService.filtroDeTerritorios$ | async) as filtros">
        <span class="control-label">Mostrar todas las rutas</span>
        <mat-slide-toggle class="slide-toggle" [checked]="this.areAllLayerFiltersActive"
            (change)="areAllLayerFiltersActive ? $event.source.checked = true : activateAllFilters(filtros)"
            [matTooltip]="this.areAllLayerFiltersActive ? 'Todas las capas están visibles' : 'Activar todas las capas'">
        </mat-slide-toggle>
    </div> -->

    <div class="territories-tab-group" *ngIf="!filter">
        <mat-tab-group [(selectedIndex)]="selectedTabIndex" class="custom-tab-group" [disablePagination]="true">
            <!-- primer tab -->
            <mat-tab>
                <ng-template mat-tab-label style="display: none;">
                    <div class="custom-tab-label">
                        <mat-icon class="tab-icon active-icon">check_circle</mat-icon>
                        <span>Activas</span>
                    </div>
                </ng-template>
                <ng-template matTabContent>

                    <div class="territories-list-container">
                        <cdk-virtual-scroll-viewport itemSize="115" class="control-items">
                            <div class="territory-card" *cdkVirtualFor="let item of $ItemsActives" [ngStyle]="(item | isTerritorySelected:selectedItems) ? {'border': 'solid 0.2vw ' + (item.idTerritory | territoryAssignedColor)} : {'border-left': 'solid 0.3vw ' + (item.idTerritory | territoryAssignedColor)}">
                                <div class="card-checkbox-area" (click)="onCardCheckboxClicked(item, $event)">
                                <div class="card-top">
                                    <div class="card-icon" [style.background-color]="item.routeType | routeTypeColor">
                                        <img [src]="(item.routeType | routeTypeIcon) | findUrl">
                                    </div>
                                    <div class="card-info">
                                        <span class="card-title active">{{ item.idTerritory }}</span>
                                        <span class="card-subtitle active">Saturación: <span style="text-shadow: 0px 0px 0px black;" [style.color]="item.saturation | saturationColor">{{ item.saturation }}</span></span>
                                    </div>

                                    <!-- Filtro de capas (de momento apagado)
                                    <div class="card-filters" *ngIf="(layerTerritoriesService.filtroDeTerritorios$ | async) as filtrosCapa">
                                        <ng-container *ngIf="filtrosCapa[item.idTerritory]">
                                            <div class="filter-checkbox" (click)="togglePolygonFilter(item.idTerritory, $event)" matTooltip="Polígono">
                                                <mat-icon [class.active]="filtrosCapa[item.idTerritory].visiblePolygon">{{filtrosCapa[item.idTerritory].visiblePolygon ? 'check_box' : 'check_box_outline_blank'}}</mat-icon>
                                                <img [src]="'icon_capas_internas_gris.svg' | findUrl" alt="">
                                                
                                            </div>
                                            <div class="filter-checkbox" (click)="toggleLocationsFilter(item.idTerritory, $event)" matTooltip="Ubicaciones">
                                                <mat-icon [class.active]="filtrosCapa[item.idTerritory].visibleLocations">{{filtrosCapa[item.idTerritory].visibleLocations ? 'check_box' : 'check_box_outline_blank'}}</mat-icon>
                                                <img [src]="'bussineLocation.png' | findUrl" alt="">
                                                
                                            </div>
                                        </ng-container>
                                    </div> -->

                                </div>
                                <div class="card-bottom">
                                    <div class="chip-container">
                                        <span class="chip" >{{ item.routeType || 'N/A' }}</span>
                                        <span class="chip">{{ item.visitDay || 'N/A' }}</span>
                                        <span class="chip" >{{ item.routeFrequency || 'N/A' }}</span>
                                    </div>
                                </div>
                                </div>
                                <div class="card-details-area" (click)="onCardDetailsClicked(item, $event)">
                                    <mat-icon>arrow_forward_ios</mat-icon>
                                </div>
                            </div>
                            <div class="no-results" *ngIf="$ItemsActives.length == 0 && !isLoading">
                                <span class="no-results-text">No se encontraron resultados</span>
                            </div>
                        </cdk-virtual-scroll-viewport>
                    </div>
                </ng-template>
            </mat-tab>

            <!-- segundo tab -->
            <!-- <mat-tab>
                <ng-template mat-tab-label style="display: none;">
                    <div class="custom-tab-label">
                        <mat-icon class="tab-icon inactive-icon">cancel</mat-icon>
                        <span>Inactivas</span>
                    </div>
                </ng-template>
                <ng-template matTabContent>

                    <div class="geofences-list-container">
                        <div class="control-items">
                            <div class="geofence-card inactive-card" *ngFor="let item of $ItemsInactives"
                                (click)="onCardClicked(item.idTerritory)">
                                <div class="card-content">
                                    <div class="card-icon">
                                        <img [src]="'geocercarOffline.png' | findUrl" width="28px">
                                    </div>
                                    <div class="card-info">
                                        <span class="card-title inactive">{{ item.name }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="no-results" *ngIf="$ItemsInactives.length == 0 && !isLoading">
                                <span class="no-results-text">No se encontraron resultados</span>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </mat-tab> -->
        </mat-tab-group>
    </div>

    <!-- Lista filtrada (fuera de tabs) -->
    <!-- <div class="clear-filters-control"
        *ngIf="filter && this.areFiltersSelected && (layerTerritoriesService.filtroDeTerritorios$ | async) as filtros">
        <span class="control-label">Mostrar todas las rutas</span>
        <mat-slide-toggle [checked]="this.areAllLayerFiltersActive"
            (change)="areAllLayerFiltersActive ? $event.source.checked = true : activateAllFilters(filtros)"
        [matTooltip]="this.areAllLayerFiltersActive ? 'Todas las rutas están visibles' : 'Activar todas las rutas'">
        </mat-slide-toggle>
    </div> -->

    <div class="territories-list-container" *ngIf="filter">
        <cdk-virtual-scroll-viewport itemSize="115" class="control-items">
            <div class="territory-card" *cdkVirtualFor="let item of $Items"
                [ngStyle]="(item | isTerritorySelected:selectedItems) ? {'border': 'solid 0.2vw ' + (item.idTerritory | territoryAssignedColor)} : {'border-left': 'solid 0.3vw ' + (item.idTerritory | territoryAssignedColor)}">
                <div class="card-checkbox-area" (click)="onCardCheckboxClicked(item, $event)">
                <div class="card-top">
                    <div class="card-icon" [style.background-color]="item.routeType | routeTypeColor">
                        <img [src]="(item.routeType | routeTypeIcon) | findUrl">
                    </div>
                    <div class="card-info">
                        <span class="card-title active">{{ item.idTerritory }}</span>
                        <span class="card-subtitle active">Saturación: <span style="text-shadow: 0px 0px 0px black;" [style.color]="item.saturation | saturationColor">{{ item.saturation }}</span></span>
                    </div>


                    <!-- <div class="card-filters" *ngIf="(layerTerritoriesService.filtroDeTerritorios$ | async) as filtrosCapa">
                        <ng-container *ngIf="filtrosCapa[item.idTerritory]">
                            <div class="filter-checkbox" (click)="togglePolygonFilter(item.idTerritory, $event)"
                                matTooltip="Polígono">
                                <mat-icon [class.active]="filtrosCapa[item.idTerritory].visiblePolygon">{{filtrosCapa[item.idTerritory].visiblePolygon ? 'check_box' : 'check_box_outline_blank'}}</mat-icon>
                                <img [src]="'icon_capas_internas_gris.svg' | findUrl" alt="">
                                
                            </div>
                            <div class="filter-checkbox" (click)="toggleLocationsFilter(item.idTerritory, $event)" matTooltip="Ubicaciones">
                                <mat-icon [class.active]="filtrosCapa[item.idTerritory].visibleLocations">{{filtrosCapa[item.idTerritory].visibleLocations ? 'check_box' : 'check_box_outline_blank'}}</mat-icon>
                                <img [src]="'bussineLocation.png' | findUrl" alt="">
                                
                            </div>
                        </ng-container>
                    </div> -->


                </div>
                <div class="card-bottom">
                    <div class="chip-container">
                        <span class="chip">{{ item.routeType || 'N/A' }}</span>
                        <span class="chip">{{ item.visitDay || 'N/A' }}</span>
                        <span class="chip">{{ item.routeFrequency || 'N/A' }}</span>
                    </div>
                </div>
                </div>
                <div class="card-details-area" (click)="onCardDetailsClicked(item, $event)">
                    <mat-icon>arrow_forward_ios</mat-icon>
                </div>
            </div>
            <div class="no-results" *ngIf="$Items.length == 0 && !isLoading">
                <span class="no-results-text">No se encontraron resultados</span>
            </div>
        </cdk-virtual-scroll-viewport>
    </div>

    <div class="edit-button-container">
        <button mat-raised-button (click)="openEditTerritories()" [disabled]="selectedItems.size < 2">
            Revisar Territorios >
        </button>
    </div>

</div>